import { CandyClient } from "@cabysis/candy-client";
import { getToken } from "@/utilities/storage";
import { BACK_END_URL } from "@/utilities/config";

const authOptions = {
  baseUrl: `${BACK_END_URL}/auth`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  getToken: () => getToken(),
};

export class AuthClient extends CandyClient {
  constructor() {
    super(authOptions);
  }

  async register(userData) {
    return this.post("/registro", userData);
  }

  async signIn(email, password) {
    return this.post("/login", {
      email,
      contrasena: password,
      customHeaders: { Authorization: `Bearer ${getToken()}` },
    });
  }

  async getUserProfile() {
    return this.get("/perfil", {
      customHeaders: { Authorization: `Bearer ${getToken()}` },
    });
  }

  // Forgot password method
  async forgotPassword(email) {
    return this.post("/forgot-password", { email });
  }

  // Reset password method
  async resetPassword(token, nuevaContrasena) {
    return this.post("/reset-password", { token, nuevaContrasena });
  }

  // Get all users method
  async getAllUsersFromOrg() {
    return this.get("/usuarios", {
      customHeaders: { Authorization: `Bearer ${getToken()}` },
    });
  }

  // Delete user method
  async deleteUser(id) {
    return this.delete(`/delete/usuarios/${id}`, {
      customHeaders: { Authorization: `Bearer ${getToken()}` },
    });
  }

  // Update user method
  async updateUser(id, dto) {
    return this.put(`/update/usuarios/${id}`, dto, {
      customHeaders: { Authorization: `Bearer ${getToken()}` },
    });
  }

  // Activate user method
  async activateUserByCode(code) {
    return this.post(`/activate/${code}`, null, {
      customHeaders: { Authorization: `Bearer ${getToken()}` },
    });
  }

  // Resend activation code method
  async resendActivationCode(email) {
    return this.post(
      "/resend-activation", { email },
    );
  }
}
